import { render, staticRenderFns } from "./FormActionButton.vue?vue&type=template&id=fa9e681a&scoped=true&lang=pug&"
import script from "./FormActionButton.vue?vue&type=script&lang=ts&"
export * from "./FormActionButton.vue?vue&type=script&lang=ts&"
import style0 from "./FormActionButton.vue?vue&type=style&index=0&id=fa9e681a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9e681a",
  null
  
)

export default component.exports